import React, {Component} from 'react'
import Dropzone from 'react-dropzone'

const encode = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k)=>{
    formData.append(k,data[k])
  });
  return formData
}

class AdminForm extends Component {

  state = {
    name: '',
    email: '',
    phone: '',
    degree: '',
    experience: '',
    message: '',
    files: [],
    covers: [],
    page: typeof window !== 'undefined' ? window.location.pathname : '',
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.refs.form.checkValidity()) return false

    fetch("https://hooks.zapier.com/hooks/catch/3298056/2218ki0/", {
      method: "POST",
      body: encode({
        "form-name": this.refs.form.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => this.setState({result: 'success'}))
      .catch(error => this.setState({result: 'fail', msg: error}))
  }

  onDrop = (files) => {
    this.setState({
      files: files,
      'file_upload': files[0]
    })
  }

  onCoverDrop = (covers) => {
    this.setState({
      covers: covers,
      'cover_upload': covers[0]
    })
  }

  render() {
    let props = {
      ref: 'form',
      name: 'contact',
      className: 'form',
      onSubmit: this.handleSubmit
    };
    if (this.state.result === 'success') {
      return (
        <div className='form__row'>
          <p>Thanks for enquiring. A member of the team will be in touch soon.</p>
        </div>
      )
    }
    let { files, covers } = this.state
    return (
      <form {...props}>
        <div className="form__row">
          <input
            type="text"
            name="name"
            placeholder="Name"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row">
          <input
            type="text"
            name="phone"
            placeholder="Contact Number"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row form__row--double">
          <input
            type="text"
            name="degree"
            placeholder="Do you have a degree?"
            onChange={this.handleChange}
            required
          />
          <input
            type="text"
            name="experience"
            placeholder="Do you have industry experience?"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row">
          <textarea
            name="message"
            placeholder="Message"
            onChange={this.handleChange}
          />
        </div>
        <div className="form__row">
          <Dropzone onDrop={this.onDrop} multiple={false}>
            {({getRootProps, getInputProps}) => (
              <div  {...getRootProps({className: 'dropzone form__dropzone'})}>
                <div className='form__file'>
                  <input name='file_upload' {...getInputProps()} />
                  { files.length === 0 && <p>Attach CV here (up to 5MB)</p> }
                  { files.length > 0 && files.map((file, i) =>
                    <div key={i}>{file.name} - {file.size} bytes</div>
                  )}
                </div>
              </div>
            )}
          </Dropzone>
        </div>
        <div className="form__row">
          <Dropzone onDrop={this.onCoverDrop} multiple={false}>
            {({getRootProps, getInputProps}) => (
              <div  {...getRootProps({className: 'dropzone form__dropzone'})}>
                <div className='form__file'>
                  <input name='cover_upload' {...getInputProps()} />
                  { covers.length === 0 && <p>Attach Cover Letter here (up to 5MB)</p> }
                  { covers.length > 0 && covers.map((cover, i) =>
                    <div key={i}>{cover.name} - {cover.size} bytes</div>
                  )}
                </div>
              </div>
            )}
          </Dropzone>
        </div>
        <div className="form__row form__row--submit">
          <button 
            type="submit" className="btn"
            onMouseEnter={() => window?._handleMouseEnter('')}
            onMouseLeave={() => window?._handleMouseLeave()}
          >
            Send It
          </button>
        </div>
      </form>
    );
  }
}

export default AdminForm